module.exports = __webpack_public_path__ + "img/1.d7ef0d74.jpg";